import { createFileRoute } from '@tanstack/react-router'

import Devices from 'pages/Devices'

export const Route = createFileRoute('/_auth/projects/$id/devices')({
  component: Devices,
})
